import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useState} from 'react';
import {FlatListGroup} from './FlatListForLogGenericState';
import {FlatListWithDetailsComponent} from './FlatListWithDetailsComponent';
import {LogOverviewViewState} from '../../views/log-overview/LogOverviewViewState';


export const FlatList: FC = observer(() => {
    const [state] = useState(() => new LogOverviewViewState());

    return <FlatListWithDetailsComponent flatListGroup={FlatListGroup.starred} state={state} />;
});
